import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {APIRoutes, ApiService, PageRoutes} from "../services/api.service";
import { HttpClient } from "@angular/common/http";
import {Roles} from "../common/roles";
import {User} from "../model/user";
import { LogService } from '../services/log.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  constructor(private api: ApiService, private nav: Router, private http: HttpClient, private logService: LogService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    /*if (this.api.user['api_token'] == undefined) {
      this.nav.navigate([PageRoutes.login.addSlash()], {replaceUrl: true})
      return false
    }*/
    if(this.api.user.uid) return true
    return this.http.get(this.api.baseurl + APIRoutes.me).toPromise().then((res: User) => {
      if (res['api_token'] == undefined) {
        this.nav.navigate([PageRoutes.login.addSlash()], {replaceUrl: true})
        return false
      }
      if (typeof res.area === "string") {
        res.area = res.area.split(',')
      }
      this.api.user = res
      return true
    }).catch(error => {

    // Log in backend
      this.logService.log("Errore login guard, rimando al login.", {
        error: error
      });

      this.nav.navigate([PageRoutes.login.addSlash()], {replaceUrl: true})
      return false
    });
  }

}
